import { ORDER_TRACKING_BACKFILL_DAYS } from "@redotech/order-tracking-common/constants";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const triggerOrderTrackingBackfill = {
  name: "triggerOrderTrackingBackfill" as const,
  input: z.object({
    teamId: zExt.objectId(),
    days: z.number().int().positive().default(ORDER_TRACKING_BACKFILL_DAYS),
  }),
  output: z.object({
    success: z.boolean(),
    workflowId: z.string().nullable(),
    error: z.string().nullable(),
  }),
};
